<script>
import Swal from "sweetalert2";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Fund Cluster",
  },
  components: {
    // Layout,
    // PageHeader,
  },
  data() {
    return {
      title: "Fund Cluster",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Fund Cluster",
          active: true,
        },
      ],
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "cluster",
      sortDesc: false,
      fields: [
        {
          key: "id",
          sortable: true,
          tdClass: "align-middle",
          thStyle: { width: "100px" },
        },
        {
          key: "cluster",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "shortName",
          sortable: true,
          label: "Short Name",
          tdClass: "align-middle",
        },
        {
          key: "uacs",
          sortable: true,
          label: "UACS",
          tdClass: "align-middle",
        },
      ],
      form: {
        id: 0,
        cluster: "",
        shortName: "",
        uacs: "",
      },
      alert: {
        type: "",
        message: "",
      },
      indexSelected: -1,
      tableBusy: false,
    };
  },
  validations: {
    form: {
      cluster: { required },
      shortName: { required },
      uacs: { required },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getData() {
      this.totalRows = this.items.length;
      this.tableBusy = true;
      this.$store
        .dispatch("finance/GetFundCluster")
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.alert = { type: "danger", message: "Something went wrong!" };
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateItem(props) {
      this.form = _.cloneDeep(props.item);
      this.indexSelected = this.tableData.indexOf(props.item);
      this.modalTitle = "Update Fund Cluster";
      this.$bvModal.show("modal-standard");
    },
    hideModal() {
      this.$bvModal.hide("modal-standard");
    },
    deleteItem(props) {
      var index = this.tableData.indexOf(props.item);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("finance/DeleteFundCluster", props.item.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.tableData.splice(index, 1);
              this.alert = {
                type: "success",
                message: "Successfully deleted",
              };
            })
            .catch(() => {
              this.alert = { type: "danger", message: "Cannot be deleted!" };
            });
        }
      });
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div
        class="card border-4 border-top border-start-0 border-end-0 border-primary"
      >
        <div class="card-body">
          <div class="row mt-1 mb-3">
            <div class="col-sm-12 col-md-6">
              <div class="d-flex align-items-center h-100">
                <h5 class="mb-0">Fund Cluster List</h5>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="d-flex justify-content-end align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Fund Cluster..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              :items="tableData"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :busy="tableBusy"
              @filtered="onFiltered"
              bordered
              outlined
              hover
              striped
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="float-end">
                  <b-dropdown
                    id="dropdown-dropleft"
                    right
                    variant="link"
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end"
                    no-caret
                  >
                    <template #button-content>
                      <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                      @click="updateItem(row)"
                      variant="secondary"
                      ><i class="bx bx-edit font-size-18 me-1"></i
                      >Edit</b-dropdown-item
                    >
                    <b-dropdown-item @click="deleteItem(row)" variant="danger"
                      ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                      >Delete</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </Layout> -->
</template>
